import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { api, rawApi } from "@/lib";
import { IDocumentBatch } from "@/store/types";

@Module({ name: "batchIndex", dynamic: true, store: Store, namespaced: true })
export default class BatchIndexModule extends VuexModule {
  public currentBatchIndexFacility: string = "";


  get facilityCode() {
    return this.currentBatchIndexFacility;
  }

  @Mutation
  setFacilityCode(value: string) {
    this.currentBatchIndexFacility = value;
  }

  @Action
  async getBatchTaskWorkItems(payload) {
    let url = `/batchIndex?facility=${payload.facility}&taskId=${payload.taskId}&workItemStatus=${payload.workItemStatus}`;
    return await api.getAsync(url);
  }

  @Action
  async getBatchTaskWorkItem(payload) {
    let url = `/batchIndex/${payload.id}`;
    if (payload.lockBatch) {
      url = `${url}?lockBatch=true`;
    }

    return await api.getAsync(url);
  }

  @Action
  async putBatchTaskWorkItem(payload) {
    let url = `/batchIndex/${payload.id}`;

    let body = {
      targetQueueId: payload.targetQueueId,
      batch: payload.batch,
      cancelBatch: payload.cancelBatch,
      saveBatch: payload.saveBatch,
      unlockBatch: payload.unlockBatch
    }
   
    return api.putAsync(url, body)
      .then((response) => {
        return response.data;
      });
  }

  @Action
  async getBatchDocumentImage(payload) {
    let url = `/images/batch/${payload.id}/${payload.page}`;
    return await api.getAsync(url);
  }

  @Action
  async getOrderLookup(payload) {
    let url = '/batchIndex/orderLookup';

    return rawApi
      .post(url, payload)
      .then(response => {
        return response.data.lookupResults;
      });
  }

  @Action
  async getCrnLookup(payload) {
    let url = '/batchIndex/crnLookup';
    return rawApi
      .post(url, payload)
      .then(response => {
        response.data.lookupResults.forEach((x) => x.isSelected = false);
        return response.data.lookupResults;
      })
  }
}
